<template>
	<ul class="tab-bar">
		<li v-for="(tab, key) in tablist" :class="{on: (key==0)}" @click.prevent="handleSelect(key)">
			<span>{{ tab.title }}</span>
			<span v-show="tab.description" class="tab-bar-new">{{ tab.description }}</span>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'tabBar',
//		props: ['tablist'],
		props:{
			tablist: {
				type: Array,
		        default: function() {
		          return []
		        }
			},
			tabClick: {
		        type: Function,
		        default() {},
		    },
		},
		mounted: function() {
			$('li').click(function() {
				$(this).siblings().removeClass('on')
				$(this).addClass('on')
			})
		},
		methods: {
	      handleSelect(index) {
	        this.selectedIndex = index
	        this.tabClick(index);
	
	      }
	    },
	}
</script>



// WEBPACK FOOTER //
// src/components/tabBar/tabBar.vue